import App from './App'
import './backgrounds.css'
import './main.css'

export default App



// WEBPACK FOOTER //
// ./src/components/App/index.js